// extracted by mini-css-extract-plugin
module.exports = {"break":"scss_break__REpYQ","page":"scss_page__2kW01","page--active":"scss_page--active__2XDyr","pagination":"scss_pagination__2No-o"};